import React from 'react';

import Button from '@components/button/Button';
import Icon from '@components/icon/Icon';

interface LeadListEmptyViewProps {
  onCsvUpload?: () => void;
  onAddManually?: () => void;
}

const LeadListEmptyView = ({
  onCsvUpload,
  onAddManually
}: LeadListEmptyViewProps) => (
  <div className="flex flex-col items-center justify-center p-8  ">
    <div className="flex flex-col items-center gap-6 rounded-2xl bg-white p-8 shadow-lg">
      <div className="flex flex-col items-center gap-1">
        <div className="text-center text-2xl font-medium text-content">
          How would you like to import leads?
        </div>
        <div className="mt-1 text-center text-lg font-normal text-grey">
          Choose an import method to begin adding leads to your database
        </div>
      </div>

      <div className="flex items-center gap-6">
        <div className="flex min-w-80 flex-1 flex-col items-center justify-center gap-6 rounded-xl border border-grey30 bg-white p-8">
          <div className="flex h-25.5 w-29 items-center justify-center">
            <Icon name="doc-upload" size="none" className="h-25.5 w-29" />
          </div>

          {/* Content */}
          <div className="flex flex-col items-center gap-3">
            <div className="text-center text-xl font-semibold text-content">
              CSV/Excel Upload
            </div>
            <div className="whitespace-nowrap text-center text-base font-normal text-grey">
              Upload leads from spreadsheet files
            </div>
          </div>
          <Button
            variant="secondary"
            label="Start Import"
            handleClick={onCsvUpload}
            className="w-full"
          />
        </div>

        <div className="flex min-w-80 flex-1 flex-col items-center justify-center gap-6 rounded-xl border border-grey30 bg-white p-8">
          <div className="flex size-25.5 items-center justify-center">
            <Icon name="manual-add" size="none" className="size-25.5" />
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="text-center text-xl font-semibold text-content">
              Add manually
            </div>
            <div className="text-center text-base font-normal text-grey">
              Add individual leads manually
            </div>
          </div>
          <Button
            variant="secondary"
            label="Add Manually"
            size="medium"
            handleClick={onAddManually}
            className="w-full"
          />
        </div>
      </div>
    </div>
  </div>
);

export default LeadListEmptyView;
